// Reserved for future IExtender instances. Flarum's bootExtensions iterates
// `extension.extend.forEach(...)` even when an extension only patches things
// imperatively, so this export must exist as an array.
export default [];